import { render, staticRenderFns } from "./attach.vue?vue&type=template&id=d30a97c8"
import script from "./attach.vue?vue&type=script&lang=js"
export * from "./attach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports